import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _styled7 from "styled-components";
import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Button from "@xe/atom-button";
import Paragraph from "@xe/atom-paragraph";
import IconDocument from "../icons/icon-document.svg";
import IconTrash from "../icons/icon-trash.svg";
var kbThreshold = 1024;
var mbThreshold = 1048576;

var returnFileSize = function returnFileSize(number) {
  if (number < kbThreshold) {
    return number + " bytes";
  } else if (number >= kbThreshold && number < mbThreshold) {
    return (number / kbThreshold).toFixed(1) + " KB";
  }

  return (number / mbThreshold).toFixed(1) + " MB";
};

export var useFileInput = function useFileInput() {
  var _useState = useState([]),
      files = _useState[0],
      setFiles = _useState[1];

  var inputElement = useRef();

  var handleChange = function handleChange(e) {
    setFiles(e.target.files);
  };

  var clearFiles = function clearFiles() {
    setFiles([]);
    inputElement.current.value = "";
  };

  return {
    files: files,
    inputElement: inputElement,
    handleChange: handleChange,
    clearFiles: clearFiles
  };
}; // TODO check how this behaves with multiple files, fix if needed

export var FileInput = function FileInput(_ref) {
  var name = _ref.name,
      disabled = _ref.disabled,
      required = _ref.required,
      multiple = _ref.multiple,
      accept = _ref.accept,
      inputElement = _ref.inputElement,
      handleChange = _ref.handleChange,
      className = _ref.className,
      style = _ref.style,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Upload File(s)" : _ref$buttonText,
      rest = _objectWithoutPropertiesLoose(_ref, ["name", "disabled", "required", "multiple", "accept", "inputElement", "handleChange", "className", "style", "buttonText"]);

  var id = name.replace(/[\W]/g, "");
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Input, {
      type: "file",
      className: "screen-reader-only",
      name: name,
      id: id,
      ref: inputElement,
      onChange: handleChange,
      disabled: disabled,
      required: required,
      multiple: multiple,
      accept: accept
    }),
    /*#__PURE__*/
    React.createElement(Button, _extends({
      as: "label",
      htmlFor: id,
      disabled: disabled,
      className: className,
      style: style
    }, rest), buttonText))
  );
};
FileInput.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
  inputElement: PropTypes.object,
  handleChange: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  buttonText: PropTypes.node // TODO: this should change to PropTypes.string after Buttons get reworked for Pluto

};

var _StyledDiv =
/*#__PURE__*/
styled("div").withConfig({
  displayName: "_StyledDiv"
})(["width:200px;font-size:1.2rem;"]);

var _StyledImg =
/*#__PURE__*/
styled("img").withConfig({
  displayName: "_StyledImg"
})(["width:200px;height:200px;object-fit:cover;"]);

var _StyledIconDocument =
/*#__PURE__*/
styled(IconDocument).withConfig({
  displayName: "_StyledIconDocument"
})(["width:200px;height:200px;object-fit:cover;"]);

var _StyledDiv2 =
/*#__PURE__*/
styled("div").withConfig({
  displayName: "_StyledDiv2"
})(["display:flex;justify-content:space-between;"]);

var _StyledSpan =
/*#__PURE__*/
styled("span").withConfig({
  displayName: "_StyledSpan"
})(["flex-grow:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);

var _StyledSpan2 =
/*#__PURE__*/
styled("span").withConfig({
  displayName: "_StyledSpan2"
})(["white-space:nowrap;margin-left:8px;"]);

var FilePreview = function FilePreview(_ref2) {
  var file = _ref2.file;
  var isImage = file.type.split("/")[0] === "image";

  var _useState2 = useState(""),
      objectURL = _useState2[0],
      setObjectURL = _useState2[1];

  useEffect(function () {
    if (isImage) {
      setObjectURL(URL.createObjectURL(file));
      return function () {
        return URL.revokeObjectURL(file);
      };
    }
  }, [file, isImage]);
  return (
    /*#__PURE__*/
    React.createElement(_StyledDiv, null, isImage ?
    /*#__PURE__*/
    React.createElement(_StyledImg, {
      src: objectURL,
      alt: ""
    }) :
    /*#__PURE__*/
    React.createElement(_StyledIconDocument, null),
    /*#__PURE__*/
    React.createElement(_StyledDiv2, null,
    /*#__PURE__*/
    React.createElement(_StyledSpan, null, file.name),
    /*#__PURE__*/
    React.createElement(_StyledSpan2, null, "(", returnFileSize(file.size), ")")))
  );
};

FilePreview.propTypes = {
  file: PropTypes.object
};

var _StyledDiv3 =
/*#__PURE__*/
styled("div").withConfig({
  displayName: "_StyledDiv3"
})(["display:flex;justify-content:flex-end;"]);

export var FilePreviewArea = function FilePreviewArea(_ref3) {
  var files = _ref3.files,
      clearFiles = _ref3.clearFiles,
      _ref3$fallbackMessage = _ref3.fallbackMessage,
      fallbackMessage = _ref3$fallbackMessage === void 0 ? "No files currently selected" : _ref3$fallbackMessage,
      _ref3$removeFilesMess = _ref3.removeFilesMessage,
      removeFilesMessage = _ref3$removeFilesMess === void 0 ? "Remove File(s)" : _ref3$removeFilesMess,
      className = _ref3.className,
      style = _ref3.style;
  return (
    /*#__PURE__*/
    React.createElement(FileContainer, {
      className: className,
      style: style
    }, files.length !== 0 ?
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(WrappingRow, null, Array.from(files).map(function (file, index) {
      return (
        /*#__PURE__*/
        React.createElement(FilePreview, {
          file: file,
          key: index
        })
      );
    })),
    /*#__PURE__*/
    React.createElement(_StyledDiv3, null,
    /*#__PURE__*/
    React.createElement(Button, {
      type: "button",
      onClick: clearFiles,
      colorScheme: "danger",
      size: "sm"
    },
    /*#__PURE__*/
    React.createElement(IconTrash, {
      width: "16px",
      style: {
        marginRight: "8px"
      }
    }), removeFilesMessage))) :
    /*#__PURE__*/
    React.createElement(Paragraph, {
      style: {
        margin: 0,
        fontSize: "1.2rem"
      }
    }, fallbackMessage))
  );
};
FilePreviewArea.propTypes = {
  files: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  clearFiles: PropTypes.func,
  fallbackMessage: PropTypes.string,
  removeFilesMessage: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
var FileContainer =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "FileContainer"
})(["border-radius:4px;background:#f0f5fa;padding:16px;"]);
var WrappingRow =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "WrappingRow"
})(["display:flex;flex-wrap:wrap;margin-left:-16px;& > *{flex:0 0 0;margin:0 0 16px 16px;}"]);
var Input =
/*#__PURE__*/
styled.input.withConfig({
  displayName: "Input"
})(["&:focus + label{outline:2px solid #e86600;}"]);